import './FormStyles.css';
import useInputString from '../../hooks/useInputString';
import { useState } from 'react';
import ClassicButton from '../UI/ClassicButton/ClassicButton';
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';
import FromAlert from './FromAlert';
import { changePassword } from '../../http/userAPI';
import useUser from '../../hooks/useUser';
import useScreenWidth from "../../hooks/useScreenWidth";

const ChangePassword: React.FC = () => {
    const [isLoading, setLoading] = useState<boolean>(false)
    const password = useInputString('');
    const newPassword = useInputString('');
    const confirmPassword = useInputString('');
    const [passwordShown1, setPasswordShown1] = useState<boolean>(false);
    const [passwordShown2, setPasswordShown2] = useState<boolean>(false);
    const [passwordShown3, setPasswordShown3] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>('');
    const [isAlertVisible, setAlertVisible] = useState<boolean>(false);
    const [errorFields, setErrorFields] = useState<string[]>([]); 
    const user = useUser();
    const screenWidth = useScreenWidth();
    
    const togglePasswordVisibility1 = () => {
        setPasswordShown1(!passwordShown1);
    };
    
    const togglePasswordVisibility2 = () => {
        setPasswordShown2(!passwordShown2);
    };
    
    const togglePasswordVisibility3 = () => {
        setPasswordShown3(!passwordShown3);
    };
    
    const closeAlert = () => {
        setAlertVisible(false);
    };
    
    const handleChangePassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        
        const missingFields: string[] = [];
        if (!password.value) missingFields.push('password');
        if (!newPassword.value) missingFields.push('newPassword');
        if (!confirmPassword.value) missingFields.push('confirmPassword');
        
        if (missingFields.length > 0) {
            setAlertMessage('Заполните все обязательные поля.');
            setAlertVisible(true);
            setErrorFields(missingFields);
            setLoading(false);
            return;
        }
        
        if (newPassword.value !== confirmPassword.value) {
            setAlertMessage('Пароли не совпадают.');
            setAlertVisible(true);
            setLoading(false);
            return;
        }
        
        if (user.user?.userId) {
            changePassword(user.user.userId, password.value, newPassword.value)
                .then((response) => {
                    if (response.error) {
                        setAlertMessage(response.error);
                        setAlertVisible(true);
                    } else {
                        setAlertMessage(response.message || 'Успешная смена пароля.');
                        setAlertVisible(true);
                        
                        password.reset();
                        newPassword.reset();
                        confirmPassword.reset();
                    }
                })
                .catch(() => {
                    setAlertMessage('Произошла ошибка при смене пароля. Попробуйте позже.');
                    setAlertVisible(true);
                })
                .finally(() => {
                    setLoading(false);
                    setErrorFields([]);
                });
        }
    };
    
    return (
        <div className='form_container update'>
            <h2>Смена пароля</h2>
            <form className="form">
                {isAlertVisible && (
                    <FromAlert onClose={closeAlert}>
                        {alertMessage}
                    </FromAlert>
                )}
                <div className='form_inputContainer'>
                    <p>Текущий пароль</p>
                    <div className='input_passwordWrapper'>
                        <input
                            className={`password ${passwordShown1 ? '' : 'active'} ${errorFields.includes('password') ? 'error' : ''}`}
                            type={passwordShown1 ? "text" : "password"}
                            value={password.value}
                            onChange={password.onChange}
                            autoComplete="new-password"
                        />
                        
                        <div className="toggle_password" onClick={togglePasswordVisibility1}>
                            {passwordShown1 ? <EyeSlashFill /> : <EyeFill />}
                        </div>
                    </div>
                </div>
                
                <div className='form_inputContainer'>
                    <p>Новый пароль</p>
                    <div className='input_passwordWrapper'>
                        <input
                            className={`password ${passwordShown2 ? '' : 'active'} ${errorFields.includes('newPassword') ? 'error' : ''}`}
                            type={passwordShown2 ? "text" : "password"}
                            value={newPassword.value}
                            onChange={newPassword.onChange}
                            autoComplete="new-password"
                        />
                        
                        <div className="toggle_password" onClick={togglePasswordVisibility2}>
                            {passwordShown2 ? <EyeSlashFill /> : <EyeFill />}
                        </div>
                    </div>
                </div>
                
                <div className='form_inputContainer'>
                    <p>Подтверждение пароля</p>
                    <div className='input_passwordWrapper'>
                        <input
                            className={`password ${passwordShown3 ? '' : 'active'} ${errorFields.includes('confirmPassword') ? 'error' : ''}`}
                            type={passwordShown3 ? "text" : "password"}
                            value={confirmPassword.value}
                            onChange={confirmPassword.onChange}
                            autoComplete="new-password"
                        />
                        
                        <div className="toggle_password" onClick={togglePasswordVisibility3}>
                            {passwordShown3 ? <EyeSlashFill /> : <EyeFill />}
                        </div>
                    </div>
                </div>

                <ClassicButton isLoading={isLoading} onClick={handleChangePassword} width={screenWidth > 1000 ? '60%' : '100%'} height='40px' innerLoaderSize='20px'>
                    Сменить пароль
                </ClassicButton>
            </form>
        </div>
    );
}

export default ChangePassword;